import { AccountProvider, Client } from '@collinsonx/constants/enums';
import {
  Box,
  Button,
  Center,
  Container,
  Flex,
  Text,
} from '@collinsonx/design-system/core';
import AppLogo from 'components/AppLogo';
import BackButton from 'components/BackButton';
import UpdateEnvError, { devices } from 'components/UpdateEnvError';
import useError from 'hooks/useError';
import useLocale from 'hooks/useLocale';
import usePayload from 'hooks/usePayload';

import classes from './LayoutError.module.css';

const { None } = Client;

export default function LayoutError() {
  const translations = useLocale();
  const { payload, platform } = usePayload();
  const { error } = useError();

  const payloadTheme = {
    accountProvider: payload?.accountProvider ?? AccountProvider.PP,
    membershipType: payload?.membershipType ?? None,
  };

  const customErrorLayout = {
    button: error?.button ?? translations.lounge.errors.server.btn.return,
    custtomButtonClick: error?.custtomButtonClick,
    message:
      error?.message ?? translations.generic.error.unhandledError.message,
    mobileMessage:
      error?.mobileMessage ?? translations.auth.notFound.descriptionMobile,
    title: error?.title ?? translations.generic.error.unhandledError.title,
  };

  const serverErrorLayout = {
    button: translations.lounge.errors.server.btn.return,
    custtomButtonClick: undefined,
    message: translations.lounge.errors.server.description,
    mobileMessage: translations.auth.notFound.descriptionMobile,
    title: translations.lounge.errors.server.title,
  };

  const activeErrorLayout = error ? customErrorLayout : serverErrorLayout;

  const { button, custtomButtonClick, message, mobileMessage, title } =
    activeErrorLayout;

  return (
    <Container
      aria-label={translations.generic.labels.error}
      className={classes.container}
      fluid
      px={0}
    >
      {payload && (
        <Box className={classes.logoWrapper} mb={2} mt={2}>
          <AppLogo
            accountProvider={payloadTheme.accountProvider}
            membershipType={payloadTheme.membershipType}
          />
        </Box>
      )}
      <Center
        style={{
          alignItems: 'center',
          display: 'flex',
          height: '70%',
        }}
      >
        <Box className={classes.containerContent} p={20}>
          <Text className={classes.center} fw={700} size="xl">
            {title}
          </Text>
          <Text className={classes.center} mb={18}>
            {message}
          </Text>
          <Box pb={10} pt={10}>
            <Flex className={classes.errorContainer} direction="column">
              {' '}
              <UpdateEnvError type={platform as devices} />
              {(platform === 'ios' || platform === 'android') && (
                <Text mb={3} mt={3}>
                  {mobileMessage}
                </Text>
              )}
            </Flex>
          </Box>
          <Center>
            {custtomButtonClick ? (
              <Button onClick={custtomButtonClick}>{button}</Button>
            ) : (
              <BackButton>{button}</BackButton>
            )}
          </Center>
        </Box>
      </Center>
    </Container>
  );
}
